import { addYears } from 'lib/datetime/dateUtils'
import { setCookie } from 'lib/web/cookieUtils'

export const BETA_AI_TRIP_BANNER_DISMISSED_KEY = 'batbdk'

export function betaAiTripBannerDismissed() {
  const in2YearsInSeconds = Math.floor(addYears(new Date(), 2).getTime() / 1000)
  setCookie(BETA_AI_TRIP_BANNER_DISMISSED_KEY, '1', in2YearsInSeconds, '/', 'Lax')
}
